import { useRef, useContext } from 'react';

import { SideNavContext } from './SideNavContext.jsx';

export default function PageContentColumn({ stickyContent, children }) {
  const { placeholderStyles } = useContext(SideNavContext);

  const stickyPlaceholderRef = useRef(null);
  const stickyRef = useRef(null);

  return (
    <div
      id="contentId"
      className="lds-side-nav-content"
    >
      <div
        className="lds-side-nav-placeholder"
        style={placeholderStyles}
      />

      {stickyContent
        && <><div
          ref={stickyPlaceholderRef}
          // :style="{ height: `${stickyHeight}px`, }"
          // :class="`lds-side-nav-sticky-placeholder`"
        ></div>
        <div
          ref={stickyRef}
          className="lds-sticky lds-side-nav-sticky"
          // :style="{ top: `${height}px` }"
          // :aria-live="stickySlotAriaLive"
        >
          {stickyContent}
        </div></>
      }

      {/* <!-- DEFAULT SLOT (USUALLY CONTAINS THE main PAGE CONTENT INJECTION POINT) --> */}
      {children}
    </div>
  );
}
